// Module
var code = "<div class=\"fpd-product-stage\"></div> <div class=\"fpd-warnings\"></div> <div class=\"fpd-advanced-image-editor fpd-hidden\"> <canvas></canvas> <span class=\"fpd-close\"><span class=\"fpd-icon-close\"></span></span> <span class=\"fpd-done\"><span class=\"fpd-icon-done\"></span></span> </div>";
// Exports
module.exports = code;